export default __webpack_public_path__ + "static/hero-2-lg-99cbc9b8bd94a7e482f5a364720253c2.png";